// extracted by extract-css-chunks-webpack-plugin
module.exports = {"suggestionWrapper":"_310Jt9"};